import axiosClient from "./axiosClient";

const url = "/contacts";

export const contactApi = {
  // Get contacts with filtering
  getAll(params) {
    return axiosClient.get(url, { params });
  },

  // Get contact by ID
  getById(id) {
    return axiosClient.get(`${url}/${id}`);
  },

  // Update contact status
  updateStatus(id, data) {
    return axiosClient.put(`${url}/${id}/status`, data);
  },

  // Delete contact
  delete(id) {
    return axiosClient.delete(`${url}/${id}`);
  },
};
